module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABkCAYAAABHLFpgAAAAFklEQVR42mP4+vXrf4YRSfwHghFJAACZZoikJCcdTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_tableau.png
// module id = RKcq
// module chunks = 2